import {
  PhoneCompany,
  WhatsAppConfig,
} from "../../../services/generated/waba-api/models";

function normalizePhone(value?: string | null): string {
  return (value || "").replace(/\D/g, "");
}

/** Merge WhatsApp configs with company numbers so every line appears in GP lists. */
export function mergeCompanyPhoneConfigs(
  configs: WhatsAppConfig[] | null | undefined,
  phones: PhoneCompany[] | null | undefined,
): WhatsAppConfig[] {
  const configList = configs ?? [];
  const phoneList = phones ?? [];
  const seen = new Set(
    configList
      .map((config) => normalizePhone(config.phoneNumber))
      .filter(Boolean),
  );

  const merged: WhatsAppConfig[] = [...configList];

  for (const phone of phoneList) {
    const key = normalizePhone(phone.phoneNumber);
    if (!key || seen.has(key)) {
      continue;
    }
    seen.add(key);
    merged.push({
      phoneNumber: phone.phoneNumber,
      label: phone.label,
    });
  }

  return merged;
}

export function resolvePrimaryWabaId(
  configs: WhatsAppConfig[],
): string | undefined {
  return configs.find((config) => !!config.wabaId)?.wabaId;
}
